import styles from "../products/analytics-table.module.css"

export default function SupplierCostAnalysis({ anomalies }) {
  return (
    <div className={styles.tableContainer}>
      <h2>Cost Analysis</h2>
      <div className={styles.tableWrapper}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>Supplier</th>
              <th>Product</th>
              <th>Orders</th>
              <th>Min Cost</th>
              <th>Avg Cost</th>
              <th>Max Cost</th>
              <th>Cost Variance</th>
              <th>Variance %</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {anomalies?.map((analysis, index) => (
              <tr key={index}>
                <td>{analysis._id.supplier}</td>
                <td>{analysis._id.product}</td>
                <td>{analysis.orders}</td>
                <td>₹{analysis.minCost.toFixed(2)}</td>
                <td>₹{analysis.avgCost.toFixed(2)}</td>
                <td>₹{analysis.maxCost.toFixed(2)}</td>
                <td>₹{analysis.costVariance.toFixed(2)}</td>
                <td>{analysis.costVariancePercent}%</td>
                <td>
                  <span className={analysis.suspiciousVariance ? styles.warning : styles.success}>
                    {analysis.suspiciousVariance ? "Suspicious" : "Normal"}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}
